import { extractSectionId, matchesMediaQuery, waitForEvent, __privateAdd, __privateGet, __privateMethod, throttle } from "theme";
import { _createAnimatedElementAnimation } from "theme-ghd";

var _onScrollListener, _onScroll, onScroll_fn;

var ImageSequenceGHD = class extends HTMLElement {
    constructor() {
      super();
      __privateAdd(this, _onScroll);
      __privateAdd(this, _onScrollListener, throttle(__privateMethod(this, _onScroll, onScroll_fn).bind(this)));
	  
    }

    connectedCallback() {		
		if (Shopify.designMode) {
			document.addEventListener("shopify:section:load", (event) => this._initialise(event));
			document.addEventListener("shopify:section:unload", (event) => this._initialise(event));
			document.addEventListener("shopify:section:reorder", (event) => this._initialise(event));
		}
		
		window.addEventListener("scroll", __privateGet(this, _onScrollListener));
		
    }

    disconnectedCallback() {
		window.removeEventListener("scroll", __privateGet(this, _onScrollListener));
    }
	
	get section() {
		const sectionId = extractSectionId(this);
		return document.getElementById('shopify-section-' + sectionId);
	}
	
	get imageSequenceGroup() {
		return this.querySelector('.image-sequence__group');
	}
	
	get imageSequenceBlocks() {
		return Array.from(this.querySelectorAll('.image-sequence-block'));
	}
	
	get totalFrames() {
		return Number(this.imageSequenceGroup.getAttribute('total-frames'));
	}
	
	get initialFrame() {
		return Number(this.imageSequenceGroup.getAttribute('initial-frame'));
	}
	
	get sequenceName() {
		return this.imageSequenceGroup.getAttribute('sequence-name');
	}
	
	get imageFormat() {
		return this.imageSequenceGroup.getAttribute('image-format');
	}
	
	get disableAnimationOut() {
		return this.getAttribute('disable-animation-out');
	}
	
	get canvas() {
		return this.querySelector("canvas");
	}
	
	_initialise(event) {
		if (this.scrollTriggerTimeline) {
			this.scrollTriggerTimeline.kill();
		}
		if (ScrollTrigger.getById(this.id)) {
			ScrollTrigger.getById(this.id).kill(true);
		}
		
		this._createAnimations();
	}
	
	_createAnimations() {
		this.scrollTriggerTimeline = gsap.timeline().pause();
		
		let animationDuration = this.totalFrames * 3.5,
			_this = this;
		
		if (this.section && this.section.previousElementSibling && this.section.previousElementSibling.classList.contains('shopify-section--image-sequence')) {
			gsap.set(
				this.section, 
				{
					autoAlpha: 0
				}
			);
			
			this.scrollTriggerTimeline.fromTo(
				this.section,
				{
					autoAlpha: 0,
				},
				{
					autoAlpha: 1,
					duration: 0.01
				},
				0
			);
		} else if (this.section)  {
			gsap.set(
				this.section, 
				{
					autoAlpha: 1
				}
			);
		}
		
		this._build();
		
		this.imageSequenceBlocks.forEach((element, index) => {
			let item = element,
				timeline = _this.scrollTriggerTimeline,
			 	componenetAnimationDuration = _this.totalFrames * 0.1,
				animationConfig = JSON.parse(item.getAttribute('data-animation')),
			 	timelineDuration = 0,
				disableTransitionOut = _this.disableAnimationOut ? true : false,
				parallaxMovement = 0;
				
			let positionIn = _this.totalFrames * (animationConfig['animate_in'] / 100),
				positionOut = _this.totalFrames * (animationConfig['animate_out'] / 100);	
	
			_createAnimatedElementAnimation(item, timeline, positionIn, positionOut, componenetAnimationDuration, timelineDuration, disableTransitionOut, animationConfig, parallaxMovement);
		});

		this.scrollTriggerConfig = {
			animation: this.scrollTriggerTimeline,
			trigger: this,
			start: "top top",
			end: "+=" + animationDuration + "%",
			scrub: true,
			id: this.id
		}
		
		this.dispatchEvent(new CustomEvent("image-sequence:after-build"));
		this.buildComplete = true;
	}
	
	currentFrame(index) {
		return `https://${Shopify.shop}/cdn/shop/files/${this.sequenceName}${(index + this.initialFrame).toString().padStart(4, '0')}${this.imageFormat}?width=${this.canvas.width}`
	}
	
    _build() {
  	  var _this = this;
  	  var initialFrame = this.initialFrame || 0;
	  
	  this.context = this.canvas.getContext("2d");
	  
  	  this.images = [];
  	  this.currentFrameObject = {
  		  frame: 0
  	  };
	  
  	  this._getImages(true);
	  this._preloadImages();
		  
  	  ScrollTrigger.create({
  		  trigger: this.canvas,
  		  start: "top bottom",
  		  once: true,
  		  onEnter: () => this._getImages(false),
  	  });
	  		  
  	  this.scrollTriggerTimeline.to(
  		  this.currentFrameObject, 
  		  {
  			  frame: this.totalFrames - 1,
  			  snap: "frame",
  			  ease: "none",
  			  duration: this.totalFrames,
  			  onUpdate: this._render.bind(this) // use animation onUpdate instead of scrollTrigger's onUpdate
  		  },
  		  '>'
  	  );
  	}
	
	_preloadImages() {
		for (var i = 0; i < (this.totalFrames + 1); i++) {
			if (i%2==0) {
				const link = document.createElement('link');
				link.href = this.currentFrame(i);
				link.rel = 'preload';
				link.as = 'image';
				link.fetchpriority = 'low';
				document.getElementsByTagName('head')[0].appendChild(link);
			}
			
		}
	}
	
	_getImages(initial) {
		for (var i = 0; i < (this.totalFrames + 1); i++) {
			  
			if (initial) {
				
				if (i < 1) {
					var img = document.createElement('img');
					this.images.push(img);
					img.src = this.currentFrame(i);
					if (i == 0) {
						if (img.complete) {
							this._render();
						} else {
							img.onload = this._render.bind(this);
						}
					};
				} else {
					break;
				}
			} else {
				if (i < 1) {
					continue;
				}
				var img = document.createElement('img');
				this.images.push(img);
				img.src = this.currentFrame(i);
			}
		}
	}
	
	_render() {
		if (this.images[this.currentFrameObject.frame].complete) {
			this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
			this.context.drawImage(this.images[this.currentFrameObject.frame], 0, 0); 
		}
	}
};


_onScrollListener = new WeakMap();
_onScroll = new WeakSet();
onScroll_fn = async function() {
	if (!this.buildComplete || window.scrollY == 0) {
	    return;
	}
	
	if (this.images[this.currentFrameObject.frame] && this.images[this.currentFrameObject.frame].complete) {
		this._render();
		window.removeEventListener("scroll", __privateGet(this, _onScrollListener));
	} else if (this.images[this.currentFrameObject.frame]) {
		this.images[this.currentFrameObject.frame].onload = this._render.bind(this);
		window.removeEventListener("scroll", __privateGet(this, _onScrollListener));
	}
};

if (!window.customElements.get("image-sequence-ghd")) {
	window.customElements.define("image-sequence-ghd", ImageSequenceGHD);
}